// extracted by mini-css-extract-plugin
export var container = "_cg-0";
export var icon = "_cg-1";
export var text = "_cg-2";